import { useTranslation } from "react-i18next";
import type { LunchMenuSummary } from "../../../../api/lunchMenus";
import { lunchScheduleText } from "../lunchDraft";
import { LunchStatusPill } from "./LunchStatusPill";

interface LunchMenuCardProps {
  menu: LunchMenuSummary;
  selected: boolean;
  onSelect: (menuId: number) => void;
}

/** Карта в списъка с обедни менюта — вида на картата на маса (избрана = pos-marked + accent рамка). */
export const LunchMenuCard = ({
  menu,
  selected,
  onSelect,
}: LunchMenuCardProps) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={() => onSelect(menu.id)}
      aria-pressed={selected}
      className={`flex w-full cursor-pointer flex-col gap-1.5 rounded-[14px] border-[1.5px] px-3.5 py-3 text-left transition-colors ${
        selected
          ? "border-pos-accent bg-pos-marked"
          : "border-pos-line bg-pos-card hover:border-pos-accent/40"
      } ${menu.status === "past" && !selected ? "opacity-75" : ""}`}
    >
      <span className="flex items-center gap-2">
        <span className="min-w-0 flex-1 truncate text-[17px] font-bold leading-[1.2] text-pos-ink">
          {menu.name}
        </span>
        <LunchStatusPill menu={menu} />
      </span>
      <span className="flex items-center gap-3 text-[13px] text-pos-soft2">
        <span className="min-w-0 truncate font-pos-mono">
          {lunchScheduleText(t, menu)}
        </span>
        <span className="ml-auto shrink-0">
          {t("lunchMenu.productsCount", { count: menu.itemCount })}
        </span>
      </span>
    </button>
  );
};
